import React, { useCallback, useEffect, useState } from 'react';
import { useTranslate } from '../../../../core/translate';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalFooterCustomButton,
} from '../../modal/Modal';

const NotificationModal = ({ message, headline, onClose }) => {
  const translate = useTranslate();
  const closeButtonLabel = translate('byo.page.general.close');
  const [showGradient, setGradient] = useState();
  const [modalInnerEl, setModalInnerEl] = useState();
  const modalInnerRef = useCallback((node) => {
    setModalInnerEl(node);
  });

  useEffect(() => {
    const modalBodyEl = modalInnerEl?.parentElement;
    const scrollAvailableCheck = () => {
      setGradient(modalInnerEl.scrollHeight > modalBodyEl.clientHeight);
    };

    const scrolledToBottomCheck = () => {
      // scrollHeight, scrollTop, and clientHeight are all rounded which
      // could potentially lead to a 3px error if all align, so used that
      // value as a threshold
      const isPartiallyScrolled =
        Math.abs(
          modalBodyEl.scrollHeight -
            modalBodyEl.scrollTop -
            modalBodyEl.clientHeight
        ) > 3;

      if (isPartiallyScrolled !== showGradient) {
        setGradient(isPartiallyScrolled);
      }
    };

    if (modalInnerEl) {
      scrollAvailableCheck();

      window.addEventListener('resize', scrollAvailableCheck);
      modalBodyEl.addEventListener('scroll', scrolledToBottomCheck);
    }

    return () => {
      window.removeEventListener('resize', scrollAvailableCheck);
      modalBodyEl?.removeEventListener('scroll', scrolledToBottomCheck);
    };
  }, [modalInnerEl]);

  return (
    <Modal
      isOpen={true}
      fullscreen={false}
      className="notification-disclosure__modal"
      overlayClassName="notification-disclosure__modal-overlay"
      contentLabel={headline}
      onRequestClose={onClose}>
      <ModalBody
        innerClassName="notification-disclosure__modal-body__inner"
        bodyRef={modalInnerRef}>
        <h1
          className="notification-disclosure__header"
          dangerouslySetInnerHTML={{ __html: headline }}
        />
        <p
          className="notification-disclosure__body"
          dangerouslySetInnerHTML={{ __html: message }}
        />
        {showGradient && (
          <div className="notification-disclosure__scroll-gradient" />
        )}
      </ModalBody>
      <ModalFooter
        className="notification-disclosure__footer"
        innerClassName="notification-disclosure__modal-footer__inner">
        <ModalFooterCustomButton
          className="notification-disclosure__footer-button stat-button-link"
          onSelect={onClose}
          data-dtm={headline}>
          {closeButtonLabel}
        </ModalFooterCustomButton>
      </ModalFooter>
    </Modal>
  );
};

export default NotificationModal;
